<template>
  <!-- no-close-on-backdrop -->
  <b-modal
    :id="modalId"
    content-class="edit-profile"
    centered
    :hide-footer="true"
    :hide-header="false"
    :size="modalSize"
    :no-close-on-backdrop="noCloseOnOutsideClick"
    :no-close-on-esc="noCloseOnEscape"
    @show="shown"
    @hide="hidden"
  >
    <template slot="modal-header" class="modal-header">
      <slot name="header"></slot>
      <button
        v-if="btnClose"
        type="button"
        class="close"
        data-dismiss="modal"
        @click="$bvModal.hide(modalId)"
      >
        &times;
      </button>
    </template>
    <slot name="modal-body"></slot>
    <slot name="modal-footer"></slot>
  </b-modal>
</template>

<script>
import Windowsize from '@/mixins/Windowsize'
export default {
  name: 'BaseModal',
  props: {
    modalId: {
      type: String,
      default: '',
    },
    modalSize: {
      type: String,
      default: 'md',
    },
    noCloseOnOutsideClick: {
      type: Boolean,
      default: false,
    },
    noCloseOnEscape: {
      type: Boolean,
      default: false,
    },
    btnClose: {
      type: Boolean,
      default: true,
    },
  },
  mixins: [Windowsize],
  methods: {
    shown() {
      if (this.windowSize < 575)
        document.body.style.setProperty('overflow-y', 'hidden')
    },
    hidden() {
      if (this.windowSize < 575)
        document.body.style.setProperty('overflow-y', 'auto')
    },
  },
}
</script>

<style lang="scss" scoped>
#loyalty-information___BV_modal_header_ {
  display: none;
}
/deep/.edit-profile {
  .iti__flag {
    border-radius: 0;
  }

  .modal-header {
    border-bottom: none;
    padding: calc(#{$px20} + (34 - 20) * ((100vw - #{$px320}) / (1920 - 320)))
      calc(#{$px20} + (34 - 20) * ((100vw - #{$px320}) / (1920 - 320))) 0;
    .btn-arrow {
      padding: 0;
      background-color: $transparent;
    }

    .modal-title {
      letter-spacing: 0.7px;
      font-weight: bold !important;
      // padding-left: $px10;
    }

    .close {
      padding: $px12 $px15;
      font-weight: 300;
      font-size: calc(
        #{$px24} + (28 - 24) * ((100vw - #{$px320}) / (1920 - 320))
      );
    }
  }
  .modal-body {
    padding: calc(
      #{$px20} + (34 - 20) * ((100vw - #{$px320}) / (1920 - 320))
    ) !important;

    .default-form {
      .form-group {
        margin-bottom: calc(
          #{$px20} + (34 - 20) * ((100vw - #{$px320}) / (1920 - 320))
        );

        label {
          margin-bottom: $px15;
          line-height: $px22 !important;
        }

        input {
          line-height: $px22;
          letter-spacing: 0.5px;
          &::placeholder {
            color: rgba($black, 0.5);
            opacity: 0.5;
          }
        }
      }
    }

    .btns {
      text-align: right;

      .btn {
        + .btn {
          margin-left: $px8;
        }
      }

      .btn-outline {
        border-color: $font-color;
        color: $font-color;

        &:hover {
          background: $font-color;
          color: $white;
        }
      }
    }
  }
}
.body-rtl {
  margin-left: 0.5rem;
  .modal-header {
    .close {
      margin: -1rem auto -1rem -1rem;
    }
  }
  .modal-body {
    .btns {
      text-align: left;
    }
    label {
      text-align: right;
      float: right;
    }
  }
}
</style>
